import React from 'react';

import { CircularProgress, Typography } from '@mui/material';

import { LoadingWrapper } from './styled-components';

interface LoadingStateProps {
  children: React.ReactNode;
}

export const LoadingState: React.FC<LoadingStateProps> = ({ children }) => (
  <LoadingWrapper role="status">
    <CircularProgress size={24} />

    <Typography>{children}</Typography>
  </LoadingWrapper>
);
